package uz.ferro.erp.feature.text.model

import kotlinx.serialization.Serializable

@Serializable
data class TextItem(
    val style: TextStyle? = null,
    val text: String? = null
)